<template>
    <section>
        <div class="page-wrap">
            <div class="main-container">
                <div class="box-content">
                    <div class="box-content-inner bricks">
                        <h2 class="main-headline">YOUR PROJECT. YOUR VISION.</h2>
                        <p class="subheadline">With over 30+ years of experience, Fund Raisers, Ltd. has hand selected
                            <br/> each product to ensure that you receive only the best in the industry with
                            <br/> the right balance of quality, aesthetics, and affordability.
                        </p>

                        <router-link tag="a" class="back-button" to="/products">
                            Back to products
                        </router-link>

                        <strong class="click-line">Click any tile to view our Virtual Brick Feature!</strong>
                        <ul class="bricks-list tiles-list">
                            <li>
                                <div class="bricks-info">
                                    <router-link tag="a" to="/virtual/red-blend-tile">
                                        <img src="images/Products-Page/tilesredblend.png" alt="">
                                        <h6 class="headline-sm">RED BLEND TILE</h6>
                                    </router-link>
                                </div>
                                <div class="bricks-sizes">
                                    <strong>3 5/8” x 7 5/8” x 1/2”</strong>
                                    <strong>7 5/8” x 7 5/8” x 1/2”</strong>
                                </div>
                            </li>
                            <li>
                                <div class="bricks-info">
                                    <router-link tag="a" to="/virtual/medium-ironspot-tile">
                                        <img src="images/Products-Page/tilesmediron.png" alt="">
                                        <h6 class="headline-sm">MEDIUM IRONSPOT TILE</h6>
                                    </router-link>
                                </div>
                                <div class="bricks-sizes">
                                    <strong>3 5/8” x 7 5/8” x 1/2”</strong>
                                    <strong>7 5/8” x 7 5/8” x 1/2”</strong>
                                </div>
                            </li>
                            <li>
                                <div class="bricks-info">
                                    <router-link tag="a" to="/virtual/manganese-tile">
                                        <img src="images/Products-Page/tilesmanganese.png" alt="">
                                        <h6 class="headline-sm">MANGANESE TILE</h6>
                                    </router-link>
                                </div>
                                <div class="bricks-sizes">
                                    <strong>3 5/8” x 7 5/8” x 1/2”</strong>
                                    <strong>7 5/8” x 7 5/8” x 1/2”</strong>
                                </div>
                            </li>

                        </ul>
                        <h6 class="title-line">
                            <div class="line"></div>
                            <span>DON’T FORGET!</span>
                            <div class="line"></div>
                        </h6>
                        <ul class="sublist">
                            <li>
                                <img src="images/Products-Page/products8.png" alt="">
                                <h6 class="headline-sm">FREE MARKETING BRICK</h6>
                                <span>A great marketing tool to connect your product to your supporters.</span>
                            </li>
                            <li>
                                <img src="images/Products-Page/products9.png" alt="">
                                <h6 class="headline-sm">BLANK BRICKS</h6>
                                <span>A one-stop shop! Order blank bricks to complete your project.</span>
                            </li>
                            <li>
                                <img src="images/Products-Page/products10.png" alt="">
                                <h6 class="headline-sm">REPLICA BRICKS</h6>
                                <span>An extra source of revenue that can be enjoyed in your home or office.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'tiles',
        metaInfo: {
            title: 'Tiles',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Select your Tile among Red Blend, Medium Ironspot, Manganese and view it with your inscription in our Virtual Brick Feature.'
                }
            ]
        }
    }
</script>




// WEBPACK FOOTER //
// Tiles.vue?40110452